// REISOR_PHASE3B_REGISTRATION_OUTCOME_V1

const NON_CARGO = new Set([
  "SPECIAL",
  "TOW",
  "PASSENGER",
]);

export function resolveRegistrationOutcome(
  data = {},
  fallbackCategory = "CARGO"
) {
  const driver = data?.driver || {};

  const driverId =
    data?.driverId ||
    driver?._id ||
    driver?.id ||
    driver?.driverId ||
    "";

  const token =
    data?.token ||
    data?.accessToken ||
    data?.jwt ||
    data?.driverToken ||
    "";

  const performerCategory = String(
    driver?.performerCategory ||
    fallbackCategory ||
    "CARGO"
  )
    .trim()
    .toUpperCase();

  const status = String(
    driver?.status || "draft"
  )
    .trim()
    .toLowerCase();

  const pendingPerformer =
    NON_CARGO.has(performerCategory) &&
    status !== "approved";

  return {
    driverId,
    token,
    performerCategory,
    status,
    pendingPerformer,
    driverSnapshot: {
      ...driver,
      _id: driverId,
      id: driverId,
      driverId,
      performerCategory,
      status,
    },
  };
}
